import {type CurriedFunction} from 'types';

export const emptyFunction = () : void => {};

export const emptyCurriedFunction : CurriedFunction = () => emptyFunction;
